function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from "react";
import BasicObjectFieldTemplate from "./basic-object-field-template";
import RootObjectFieldTemplate from "./root-object-field-template";

var GridObjectFieldTemplate = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(GridObjectFieldTemplate, _React$Component);

  function GridObjectFieldTemplate() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = GridObjectFieldTemplate.prototype;

  _proto.render = function render() {
    var idSchema = this.props.idSchema;

    if (idSchema.$id === "root") {
      return /*#__PURE__*/React.createElement(RootObjectFieldTemplate, this.props);
    }

    return /*#__PURE__*/React.createElement(BasicObjectFieldTemplate, this.props);
  };

  return GridObjectFieldTemplate;
}(React.Component);

export default GridObjectFieldTemplate;